"use client";

import styles from "./styles.module.css";
import Button from "@components/atoms/Button";
import H2 from "@components/atoms/H2";
import SwiperImage from "@components/atoms/Swiper";
import Tabs from "@components/atoms/Tabs";
import { useIsMobile } from "common/hooks/useIsMobile";
import { useTranslations } from "next-intl";
import Image from "next/image";
import React from "react";

export default function SolutionsSubPagesTemplate2({
  sections,
  translation,
  hasSwiper,
  shouldHaveGridTabs,
}: {
  sections: any;
  translation: string;
  hasSwiper?: boolean;
  shouldHaveGridTabs?: boolean;
}) {
  const t = useTranslations(translation);
  const isMobile = useIsMobile();
  const handleReadMore = (link: string) => {
    window.open(link, "_self");
  };

  return (
    <section className={styles.container}>
      {sections.map((item: any, key: number) => {
        return (
          <div key={key} className="w-full">
            {isMobile ? (
              item.titleMobile ? (
                <H2
                  translation={`${translation}.${key}`}
                  text={"titleMobile"}
                  style={styles.container__h2}
                />
              ) : (
                <H2
                  translation={`${translation}.${key}`}
                  text={"title"}
                  style={styles.container__h2}
                />
              )
            ) : (
              <H2
                translation={`${translation}.${key}`}
                text={"title"}
                style={styles.container__h2}
              />
            )}
            <div
              key={t(`${key}.title`)}
              className={`
          justify-between
          items-center
          mt-20
          w-full  
          flex 
          ${
          key % 2
            ? "flex flex-col-reverse md:flex-row-reverse"
            : "flex flex-col-reverse  md:flex-row"
          }
            `}
            >
              <div className="md:w-[48%] xs:w-full flex flex-col items-center md:items-start">
                <Tabs
                  content={sections[key]}
                  upperTabs={true}
                  translations={`${translation}.${key}.content`}
                  shouldHaveGridTabs={shouldHaveGridTabs}
                  sectionIndex={key}
                />
                {item.button && (
                  <Button
                    translation={`${translation}.${key}`}
                    text={"button"}
                    style="w-fit flex"
                    onClickEvent={() => handleReadMore(t(`${key}.link`))}
                  />
                )}
              </div>
              <div className={styles.container__swiper}>
                {hasSwiper && <SwiperImage slides={item.images} />}
                {!hasSwiper && (
                  <Image
                    width={620}
                    height={350}
                    src={item.img || "/logo-labs-white.webp"}
                    alt="icon"
                    title="icon"
                    className="object-contain self-center"
                  />
                )}
              </div>
            </div>
            {key !== sections.length - 1 && <FadedLine />}
          </div>
        );
      })}
    </section>
  );
}

function FadedLine({
  color,
  height,
  width,
}: {
  color?: string;
  height?: string;
  width?: string;
}) {
  return (
    <div className={`flex  my-16 h-[2px] w-[100%]`}>
      <div
        className={`flex-1 bg-gradient-to-r from-transparent to-[#4E18A7]`}
      ></div>
      <div className={`h-full w-4 bg-[#4E18A7]`}></div>
      <div
        className={`flex-1 bg-gradient-to-r from-[#4E18A7] to-transparent`}
      ></div>
    </div>
  );
}
